var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCalendar(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    rx: 5,
    fill: "#403E3E"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.1238 4.10043H10.6849V3.22266H9.80712V4.10043H6.29601V3.22266H5.41823V4.10043H4.97934C4.49217 4.10043 4.10595 4.49543 4.10595 4.97821L4.10156 11.1227C4.10156 11.6054 4.49217 12.0004 4.97934 12.0004H11.1238C11.6066 12.0004 12.0016 11.6054 12.0016 11.1227V4.97821C12.0016 4.49543 11.6066 4.10043 11.1238 4.10043ZM11.1238 11.1227H4.97934V6.73377H11.1238V11.1227ZM11.1238 5.85599H4.97934V4.97821H11.1238V5.85599ZM6.7349 8.48932H5.85712V7.61154H6.7349V8.48932ZM8.49045 8.48932H7.61267V7.61154H8.49045V8.48932ZM10.246 8.48932H9.36823V7.61154H10.246V8.48932ZM6.7349 10.2449H5.85712V9.3671H6.7349V10.2449ZM8.49045 10.2449H7.61267V9.3671H8.49045V10.2449ZM10.246 10.2449H9.36823V9.3671H10.246V10.2449Z",
    fill: "#FFFDFC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendar);
export default __webpack_public_path__ + "static/media/calendar.a9a63cdba19f60ac4ec8633b594b8790.svg";
export { ForwardRef as ReactComponent };